'use client';
import Cookies from 'js-cookie';
import { useEffect } from 'react';

export default function PebblePostId() {
  useEffect(() => {
    if (window !== undefined) {
      let count = 0;
      function waitforPebblePost() {
        return new Promise((resolve) => {
          if (window?.['_pp']?.ppid) {
            return resolve(window?.['_pp']?.ppid);
          }

          const interval = setInterval(() => {
            if (window?.['_pp']?.ppid || count >= 50) {
              clearInterval(interval);
              resolve(window?.['_pp']?.ppid);
            }
            count++;
          }, 100);
        });
      }
      waitforPebblePost().then(() => {
        if (
          window?.['_pp']?.ppid &&
          window?.['_pp']?.ppid !== 'undefined' &&
          window?.['_pp']?.ppid !== '' &&
          Cookies.get('ppid') !== window?.['_pp']?.ppid
        ) {
          Cookies.set('ppid', window?.['_pp']?.ppid, { expires: 30 });
        }
      });
    }
  }, []);
  return null;
}
